/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.addEventListener('load', function(){
  let collection_add_to_cart = document.querySelectorAll('.collection-add-to-cart');
  let buy_it_now = document.querySelectorAll('.buy-it-now');
  for (var i=0; i < collection_add_to_cart.length; i++){
    collection_add_to_cart[i].addEventListener('click', addToCart);
  }
  for (var i=0; i < buy_it_now.length; i++){
    buy_it_now[i].addEventListener('click', buyItNow);
  }
  function addToCart(){
    if(this.getAttribute('data-url') != null){
    let url = this.getAttribute('data-url') + ".js";
    if (url.indexOf('?') != -1){
      url = url.split('?');
      url = url[0];
    }
    let closeDrawer = document.querySelector('.close-btn-hack');
    let overlay = document.querySelector('.PageOverlay');
    let cart = document.getElementById('sidebar-cart');
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.send(null);
    xhr.onreadystatechange = function () {
      var DONE = 4; 
      var OK = 200;
      if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
          let data = xhr.responseText; 
          data = JSON.parse(data);
          let variant_id = data.variants[0].id;
          Shopify.addItem(variant_id, 1);
//           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//             bubbles: true
//           }));
          showCart();
          closeDrawer.addEventListener('click', hideCart);
          overlay.addEventListener('click', hideCart);
          function showCart(){
            cart.setAttribute('aria-hidden', 'false');
            overlay.classList.add('is-visible');
          }
          function hideCart(){
            cart.setAttribute('aria-hidden', 'true');
            overlay.classList.remove('is-visible');
          }
        } else {
          console.log('Error: ' + xhr.status);
        }
      }
    };
  }
  }
function buyItNow(){
  if(this.getAttribute('data-url') != null){
    let url = this.getAttribute('data-url') + ".js";
    if (url.indexOf('?') != -1){
      url = url.split('?');
      url = url[0];
    }
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.send(null);
    xhr.onreadystatechange = function () {
      var DONE = 4; 
      var OK = 200;
      if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
          let data = xhr.responseText; 
          data = JSON.parse(data);
          let variant_id = data.variants[0].id;
          Shopify.addItem(variant_id, 1, {}, directToCart);

        }
      };
    }
  }
}
if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}

Shopify.onError = function(t, r) {
  var e = eval("(" + t.responseText + ")");
  e.message ? alert(e.message + "(" + e.status + "): " + e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
};

Shopify.fullMessagesFromErrors = function(t) {
  var r = [];
  return jQuery.each(t, function(t, e) {
    jQuery.each(e, function(e, a) {
      r.push(t + " " + a)
    })
  }),
  r
};

/*=========================== Fix for Shopify.money_format only formatting in USD in expansion stores =========================== */
$(function(){
if(Shopify.currency.active == 'GBP' && Shopify.money_format.indexOf('£') === -1){
  Shopify.money_format = '£{{amount}}';
}
  })

/* Ajax API */

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------

Shopify.addItem = function(variant_id, qty, properties, callback) {
  var qty = qty || 1;
  var params = {
    quantity: qty,
    id: variant_id
  }
  if(properties != false){
    params.properties = properties;
  }
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: params,
    dataType: "json",
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });
};

function directToCart(){
  setTimeout(function(){
  window.location.href = "/checkout";
    }, 1000)
}

Shopify.onItemAdded = function(line_item) {
  console.log(line_item.title + " was added to your shopping cart.");
  Shopify.getCart();
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
             bubbles: true
             }))
};

// ---------------------------------------------------------
// GET cart.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

Shopify.onCartUpdate = function(cart) {
  if($('.cart__item-count').text() != cart.item_count){
    $('.cart__item-count').text(cart.item_count);
  }
  console.log('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.removeItem = function(t, r) {
    var e = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r);
        }
    };
    jQuery.ajax(e);
};

  })
/*
window.addEventListener('load', function(){
  let collection_add_to_cart = document.querySelectorAll('.collection-add-to-cart');
  for (var i=0; i < collection_add_to_cart.length; i++){
    collection_add_to_cart[i].addEventListener('click', addToCart);
  }
  function addToCart(){
    if(this.getAttribute('data-url') != null){
      let url = this.getAttribute('data-url') + ".js";
      if (url.indexOf('?') != -1){
        url = url.split('?');
        url = url[0];
      }
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.send(null);
      xhr.onreadystatechange = function () {
        var DONE = 4; 
        var OK = 200;
        if (xhr.readyState === DONE) {
          if (xhr.status === OK) {
            let data = xhr.responseText; 
            data = JSON.parse(data);
            let variant_id = data.variants[0].id;
            let inventory_quantity = data.variants[0].inventory_quantity;
            checkAvailability(variant_id, inventory_quantity)
          } else {
            console.log('Error: ' + xhr.status);
          }
        }
      };
    }
  }
  function addItem(variant_id) {
    let closeDrawer = document.querySelector('.close-btn-hack');
    let overlay = document.querySelector('.PageOverlay');
    let cart = document.getElementById('sidebar-cart');
    let update_data = {
      quantity: 1,
      id: variant_id
    }    
    let xhr = new XMLHttpRequest;
    xhr.open('POST', '/cart/add.js')
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(update_data))
    xhr.onreadystatechange = function(){
      if(xhr.readyState === 4){
        if(xhr.status === 200){
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          showCart();
        }else {
          console.log("Error: " + xhr.status);
        }
      }    
    }
    closeDrawer.addEventListener('click', hideCart);
    overlay.addEventListener('click', hideCart);
    function showCart(){
      cart.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-visible');
    }
    function hideCart(){
      cart.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
    }
  }
  function checkAvailability(variant_id, inventory_quantity){
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js');
    xhr.send(null);
    xhr.onreadystatechange = function(){
      if(xhr.readyState === 4){
        if(xhr.status === 200){
          let cart = JSON.parse(xhr.responseText);
          let items = cart.items;
          if(items.length > 0){
          for(var i=0;i<items.length;i++){
            console.log("Cart Quantity: " + items[i].quantity + ", Inventory Quantity: " + inventory_quantity + ", Variant ID: " + variant_id + ", Item ID: " + items[i].id);
            
            if (items[i].quantity < inventory_quantity && variant_id === items[i].id){
				addItem(variant_id)
            }else if (items[i].quantity < inventory_quantity && variant_id === items[i].id) {
              console.log("You've purchased the limit of our stock")
            }
          }
          } else{
          addItem(variant_id);
          }
        }
      }
    }
  }
})
*/